import { Spinner } from '@/components/ui/Spinner'

import { OverlayContainer } from './styles'

/**
 * 풀스크린 어두운 반투명 오버레이 + 중앙 Spinner.
 * Figma: 결제 진행 / 결제 결과 확인 로딩 화면 (20814:34705).
 */
export function LoadingOverlay() {
  return (
    <OverlayContainer
      role='status'
      aria-live='polite'
      aria-label='처리 중'
    >
      <Spinner size='large' />
    </OverlayContainer>
  )
}
